<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="team !== null">

    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
          <button withRight="admin.onlinetest.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
          <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-button-sm p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}"></button>
          <p-menu #menu [popup]="true" [model]="items"></p-menu>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div class="p-grid p-fluid">
      <div class="p-col-6">
        <app-form-control [cid]="'for_ac'" [control]="form.get('for_ac')" [type]="'checkbox'" [label]="t('onlinetest_basedata.for_ac')" [edit]="inEdit" [basevalue]="onlinetest.for_ac"></app-form-control>
        <app-form-control [cid]="'for_toolbox'" [control]="form.get('for_toolbox')" [type]="'checkbox'" [label]="t('onlinetest_basedata.for_toolbox')" [edit]="inEdit" [basevalue]="onlinetest.for_toolbox"></app-form-control>
        <hr/>
        <app-form-control [cid]="'api_active'" [control]="form.get('api_active')" [type]="'checkbox'" [label]="t('onlinetest_basedata.api_active')" [edit]="inEdit" [basevalue]="onlinetest.api_active"></app-form-control>
      </div>
      <div class="p-col-6">
        <label>{{ t('onlinetest_basedata.candidate_comment') }}</label><br/>
        <div *ngIf="inEdit !== true" [innerHtml]="candidateComment | dashWhenEmpty"></div>
        <ng-container *ngIf="inEdit === true">
          <editor style="width: 100%; height: 500px;" [formControl]="form.get('candidate_comment')" [init]="getEditorInit()"></editor>
        </ng-container>
      </div>
    </div>

  </form>
</ng-container>
